import api from "./axios";

export type ProyectoPayload = {
  codigo: string;
  nombre: string;
  descripcion?: string | null;
  rol: "DEFAULT" | "TRAINING" | "A365" | "EXAM" | "HIGHPERF";
  billingMode: "FACTURABLE" | "NO_FACTURABLE" | "POR_ALUMNOS" | "ESPECIAL";
  includeInReports: boolean;
  countsInTeachingHours: boolean;
  countsInStudentReports: boolean;
  isExamFlag: boolean;
  reportGroup?: string | null;
  calendarColor?: string | null;
  activo: boolean;
};

export async function getProyectos(params: any) {
  const { data } = await api.get("/proyectos", { params });
  return data;
}
export async function getProyectosMeta() {
  const { data } = await api.get("/proyectos/meta");
  return data;
}
export async function createProyecto(data: ProyectoPayload) {
  const res = await api.post("/proyectos", data);
  return res.data;
}
export async function updateProyecto(id: number, data: Partial<ProyectoPayload>) {
  const res = await api.patch(`/proyectos/${id}`, data);
  return res.data;
}
export async function activarProyecto(id: number, activo: boolean) {
  const res = await api.patch(`/proyectos/${id}/activar`, { activo });
  return res.data;
}
export async function removeProyecto(id: number) {
  // borrado lógico (activo=false)
  const res = await api.delete(`/proyectos/${id}`);
  return res.data;
}
